export enum EmailFrequency {
  None = 'None',
  Daily = 'Daily',
  Weekly = 'Weekly',
}
